/**
 * 由于火山打通app之后，公共属性值会被覆盖，所以对事件埋点进行二次封装
 */

export const finderEvtCollect = (evtName, params) => {
  if (window.collectEvent) {
    if (params) {
      console.log('evtName----', evtName)
      window.collectEvent(evtName, params)
    } else {
      window.collectEvent(evtName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/finder.js